import { createFileRoute } from '@tanstack/react-router'

import { MessagesTab } from '@/components/zalo/messages-tab'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/zalo/messages',
)({
    component: MessagesTab,
})
